import vi_VN from 'antd/es/locale/vi_VN';
import en_US from 'antd/es/locale/en_US';
import { I18n } from './i18n';

/** Ant Design locale object — read at call time (not module load). */
export const getAntdLocale = () => (I18n.language === 'vi' ? vi_VN : en_US);
